const redboxHosts = ['uat1.dhl.dhl', 'www.dhl.com'];
const redboxPath = '/fragments/dgf-ggmat-v1';

const useBackendPath = () => {
  const hostname = window.location.hostname;
  const isRedbox = !!redboxHosts.find((redboxHost) =>
    hostname.includes(redboxHost),
  );

  return {
    isRedbox,
    backendPath: isRedbox ? redboxPath : '',
  };
};
export default useBackendPath;
